/**
 * NotificationPermButton — tarayıcı bildirim izni için küçük prompt.
 * - Zaten izinli ise görünmez
 * - Red edildiyse "ayarlardan aç" tooltip'i
 * - Default ise tek tıkla ister
 */
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { BellSlash, Bell } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function NotificationPermButton() {
  const [perm, setPerm] = useState(
    typeof window !== "undefined" && "Notification" in window
      ? Notification.permission
      : "unsupported"
  );

  useEffect(() => {
    if (perm === "unsupported") return;
    const t = setInterval(() => {
      if (Notification.permission !== perm) setPerm(Notification.permission);
    }, 2000);
    return () => clearInterval(t);
  }, [perm]);

  if (perm === "unsupported" || perm === "granted") return null;

  const ask = async () => {
    try {
      const r = await Notification.requestPermission();
      setPerm(r);
      if (r === "granted") {
        new Notification("Bildirimler açıldı", {
          body: "Artık yeni kesim görevi, sipariş vb. anında haberdar olacaksın.",
          icon: "/mossline-logo.png",
        });
        toast.success("Bildirimler açıldı");
      } else if (r === "denied") {
        toast.error("İzin reddedildi. Tarayıcı ayarlarından açabilirsin.");
      }
    } catch {
      toast.error("Bildirim izni istenemedi.");
    }
  };

  return (
    <Button
      size="sm"
      variant={perm === "denied" ? "ghost" : "outline"}
      onClick={perm === "denied"
        ? () => toast.info("Bildirim engelli: Tarayıcı > Site ayarları > Bildirimler")
        : ask}
      className="h-8 gap-1 text-xs"
      data-testid="notification-perm-button"
      title={perm === "denied" ? "Bildirim engellenmiş" : "Masaüstü bildirimlerini aç"}
    >
      {perm === "denied" ? (
        <>
          <BellSlash size={14} className="text-amber-600" />
          <span className="hidden sm:inline">Bildirim kapalı</span>
        </>
      ) : (
        <>
          <Bell size={14} />
          <span className="hidden sm:inline">Bildirimleri aç</span>
        </>
      )}
    </Button>
  );
}
